<template>
  <div class="gallery-page"> <!-- ✅ SINGLE ROOT -->

    <loader v-if="loading"></loader>

    <section class="pt-5 mt-5 bg-grey">
      <div class="container">

        <div class="main-heading pb-4">
          <h1 class="title-section">Images</h1>
        </div>

        <!-- IMAGES GRID -->
        <div class="gride-container" v-if="images.length">
          <div
            class="gride-box"
            v-for="(img, index) in images"
            :key="img.image_id"
            @click="openLightbox(index)"
          >
            <div class="loader-static">
              <div class="loader-dynamic">
                <img
                  :src="img.image"
                  @error="$event.target.src='assets/images/placeholder.png'"
                >
              </div>
              <img src="assets/images/Square.png" class="stactic-img">
            </div>
          </div>
        </div>

        <!-- NO DATA -->
        <div class="nodata" v-else>
          <h1>No Images Found</h1>
        </div>

      </div>
    <div class="text-center lmore mt-4" v-if="current_page < total_pages">
        <button class="btn btn-primary" @click="loadMore">
            Load More Photos
        </button>
    </div>

    </section>

    <!-- ✅ LIGHTBOX INSIDE SAME ROOT -->
    <div
        v-if="lightbox.open"
        class="lightbox"
        @click.self="closeLightbox"
        @touchstart="onTouchStart"
        @touchend="onTouchEnd"
        >

        <span class="close-btn" @click="closeLightbox">×</span>

        <div class="counter">
            {{ lightbox.index + 1 }} / {{ images.length }}
        </div>

        <a
            class="download-btn"
            :href="lightbox.image"
            download
            target="_blank"
        >
            ⬇ Download
        </a>

        <img :src="lightbox.image" class="lightbox-image" />

        <button class="nav prev" @click.stop="prevImage">❮</button>
        <button class="nav next" @click.stop="nextImage">❯</button>

    </div>

    
  </div>
</template>

<style>
/* Image Grid */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 30px;
}
.lmore{
    margin: 20px auto;
}

.image-card {
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.25s ease;
}

.image-card:hover {
  transform: scale(1.04);
}

.image-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

/* Lightbox */
.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.lightbox-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
}

/* Close Button */
.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 36px;
  color: #fff;
  cursor: pointer;
}

/* Navigation */
.nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 50px;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px 18px;
  opacity: 0.8;
}

.nav:hover {
  opacity: 1;
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}

/* Mobile */
@media (max-width: 600px) {
  .nav {
    font-size: 36px;
  }
}

/* Counter */
.counter {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 16px;
  opacity: 0.8;
}

/* Download */
.download-btn {
  position: absolute;
  top: 60px;
  right: 30px;
  color: #fff;
  font-size: 14px;
  text-decoration: none;
  background: rgba(255,255,255,0.1);
  padding: 6px 12px;
  border-radius: 6px;
}

.download-btn:hover {
  background: rgba(255,255,255,0.25);
}


</style>
<script>
import { HTTP } from '../../_helper/http-constants.js';

export default {
  name: "GalleryImages",
  data() {
    return {
      folderID: this.$route.params.folderID,
      images: [],
      current_page: 1,
      total_pages: 1,
      loading: false,

      // Lightbox
      lightbox: {
        open: false,
        index: 0,
        image: null
      },
      touchStartX: 0,
      touchEndX: 0
    };
  },

  methods: {
    fetchImages() {
      this.loading = true;
      HTTP.get(`/gallery/folders/${this.folderID}/images?page=${this.current_page}`)
        .then(res => {
          if (res.data.status === 200) {
            if (this.current_page === 1) {
                this.images = res.data.data || [];
            } else {
                this.images = [...this.images, ...res.data.data];
            }

                this.total_pages = res.data.total_pages;
          }
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },

    openLightbox(index) {
      this.lightbox.open = true;
      this.lightbox.index = index;
      this.lightbox.image = this.images[index].image;
      document.body.style.overflow = 'hidden';
    },

    closeLightbox() {
      this.lightbox.open = false;
      document.body.style.overflow = '';
    },

    nextImage() {
      if (this.lightbox.index < this.images.length - 1) {
        this.lightbox.index++;
      } else {
        this.lightbox.index = 0;
      }
      this.lightbox.image = this.images[this.lightbox.index].image;
    },

    prevImage() {
      if (this.lightbox.index > 0) {
        this.lightbox.index--;
      } else {
        this.lightbox.index = this.images.length - 1;
      }
      this.lightbox.image = this.images[this.lightbox.index].image;
    },

    handleKey(e) {
      if (!this.lightbox.open) return;

      if (e.key === 'Escape') this.closeLightbox();
      if (e.key === 'ArrowRight') this.nextImage();
      if (e.key === 'ArrowLeft') this.prevImage();
    },
    onTouchStart(e) {
        this.touchStartX = e.changedTouches[0].screenX;
    },

    onTouchEnd(e) {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
    },

    handleSwipe() {
        const diff = this.touchStartX - this.touchEndX;

        if (Math.abs(diff) < 50) return;

        if (diff > 0) {
        this.nextImage(); // swipe left
        } else {
        this.prevImage(); // swipe right
        }
    },
    loadMore() {
        if (this.current_page < this.total_pages) {
            this.current_page++;
            this.fetchImages();
        }
    }

  },

  mounted() {
    this.fetchImages();
    window.addEventListener('keydown', this.handleKey);
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKey);
  }
};

</script>
